<template>
  <div>
    <v-container>
      <div class="d-flex align-center mx-6 mt-4 mb-6">
        <v-icon left size="30">mdi-account-cowboy-hat</v-icon>
        <h2 class="font-weight-regular">Corp Users</h2>
      </div>
      <SearchBar
        label="Search By Email"
        v-model="queryParams.email"
        locationForm="/app/corpUserForm/add"
        @input="getAllCorpUsers()"
      />

      <CorpUserTable :corpUser="validData" :loading="isLoading" />
    </v-container>
  </div>
</template>

<script>
import api from "../../../api";
import toasts from "../../../utils/toasts";
export default {
  data() {
    return {
      isLoading: false,
      searchOptions: {
        searValue: "",
      },
      paginatedList: null,
      queryParams: {
        userId: null,
        email: null,
      },
    };
  },
  computed: {
    validData() {
      return this.paginatedList ? this.paginatedList : [];
    },
  },
  beforeMount() {
    this.getAllCorpUsers();
  },
  methods: {
    async getAllCorpUsers() {
      try {
        this.isLoading = true;
        this.paginatedList = await api.corpUsers.getPaginated(this.queryParams);
      } catch (error) {
        toasts.error(`Could not get corp user ${error}`);
        this.isLoading = false;
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
</style>